/* eslint-disable default-param-last */
/**
 * @description Reducer para preencher valores de opções em formulários - por ex: select one
 * @author Diego Sabino Amorim de Araújo
 * @file optionReducer.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

const initialState = {
  tipoArmaDeFogo: [],
  tipoGravacaoArmaDeFogo: [],
  localFabricacaoArmaDeFogo: [],
  marcaArmaDeFogo: [],
  modeloArmaDeFogo: [],
  calibreNominalArmaDeFogo: [],
  calibreArtesanalArmaDeFogo: [],
  numeracaoDeSerieArmaDeFogo: [],
  localGravacaoNumeracaoDeSerieArmaDeFogo: [],
  numeracaoDeMontagemArmaDeFogo: [],
  localGravacaoNumeracaoDeMontagemArmaDeFogo: [],
  tipoAcabamentoArmaDeFogo: [],
  estadoConservacaoArmaDeFogo: [],
  sistemaPercussaoArmaDeFogo: [],
  tipoAlmaDoCanoArmaDeFogo: [],
  comprimentoCanoArmaDeFogo: [],
  sistemaCarregamentoArmaDeFogo: [],
  tipoTamborArmaDeFogo: [],
  tipoCarregadorArmaDeFogo: [],
  sistemaFuncionamentoArmaDeFogo: [],
  tipoMecanismoDisparoArmaDeFogo: [],
  tipoMassaDeMiraArmaDeFogo: [],
  tipoAlcaDeMiraArmaDeFogo: [],
  tipoEmpunhaduraArmaDeFogo: [],
  tipoCoronhaArmaDeFogo: [],
  tipoTelhaArmaDeFogo: [],
  tipoGuardaMaoArmaDeFogo: [],
  calibreNominalCartucho: [],
  capsulaEspoletamentoCartucho: [],
  fabricanteCartucho: [],
  tipoEstojoCartucho: [],
  tipoProjetilCartucho: [],
  calibreCompativelElementoMunicao: [],
  especieElementoMunicao: [],
  ressaltosECavadosElementoMunicao: [],
  tipoElementoMunicao: [],
  autoridadesRequisitantes: [],
  numeroLoteCartucho: [],
  tiposVestigios: null,
  tiposVestigiosGenericos: [],
  tiposVestigiosEspecificos: null,
  tiposVestigiosBalistica: null,
  resultadosEficiencia: [],
  resultadosConfronto: [],
  tiposSolicitacoes: null,
  usuarios: null,
  setores: null,
  tiposExames: null,
  caracteristicasCartucho: [],
  tiposFenomenosCadavericos: null,
  tiposLesoes: null,
  causasMorte: null,
  processandoOpcoes: false,
}

const optionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PROCESSANDO_OPCOES: {
      return {
        ...state,
        processandoOpcoes: action.isProcessando,
      }
    }
    case types.CALIBRE_ARTESANAL_ARMA_DE_FOGO: {
      return {
        ...state,
        calibreArtesanalArmaDeFogo: action.opcoes,
      }
    }

    case types.RESULTADO_EFICIENCIA: {
      return {
        ...state,
        resultadosEficiencia: action.opcoes,
      }
    }

    case types.RESULTADO_CONFRONTO: {
      return {
        ...state,
        resultadosConfronto: action.opcoes,
      }
    }

    case types.CALIBRE_NOMINAL_ARMA_DE_FOGO: {
      return {
        ...state,
        calibreNominalArmaDeFogo: action.opcoes,
      }
    }

    case types.ESTADO_CONSERVACAO_ARMA_DE_FOGO: {
      return {
        ...state,
        estadoConservacaoArmaDeFogo: action.opcoes,
      }
    }

    case types.LOCAL_FABRICACAO_ARMA_DE_FOGO: {
      return {
        ...state,
        localFabricacaoArmaDeFogo: action.opcoes,
      }
    }

    case types.LOCAL_GRAVACAO_NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO: {
      return {
        ...state,
        localGravacaoNumeracaoDeMontagemArmaDeFogo: action.opcoes,
      }
    }

    case types.LOCAL_GRAVACAO_NUMERACAO_DE_SERIE_ARMA_DE_FOGO: {
      return {
        ...state,
        localGravacaoNumeracaoDeSerieArmaDeFogo: action.opcoes,
      }
    }
    case types.NUMERO_LOTE_CARTUCHO: {
      return {
        ...state,
        numeroLoteCartucho: action.opcoes,
      }
    }

    case types.MARCA_ARMA_DE_FOGO: {
      return {
        ...state,
        marcaArmaDeFogo: action.opcoes,
      }
    }

    case types.MODELO_ARMA_DE_FOGO: {
      return {
        ...state,
        modeloArmaDeFogo: action.opcoes,
      }
    }

    case types.SISTEMA_CARREGAMENTO_ARMA_DE_FOGO: {
      return {
        ...state,
        sistemaCarregamentoArmaDeFogo: action.opcoes,
      }
    }

    case types.SISTEMA_FUNCIONAMENTO_ARMA_DE_FOGO: {
      return {
        ...state,
        sistemaFuncionamentoArmaDeFogo: action.opcoes,
      }
    }

    case types.SISTEMA_PERCUSSAO_ARMA_DE_FOGO: {
      return {
        ...state,
        sistemaPercussaoArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_ACABAMENTO_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoAcabamentoArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_ALCA_DE_MIRA_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoAlcaDeMiraArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_ALMA_DO_CANO_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoAlmaDoCanoArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_CARREGADOR_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoCarregadorArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_CORONHA_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoCoronhaArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_EMPUNHADURA_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoEmpunhaduraArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_GRAVACAO_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoGravacaoArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_GUARDA_MAO_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoGuardaMaoArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_MASSA_DE_MIRA_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoMassaDeMiraArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_MECANISMO_DISPARO_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoMecanismoDisparoArmaDeFogo: action.opcoes,
      }
    }

    case types.NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO: {
      return {
        ...state,
        numeracaoDeMontagemArmaDeFogo: action.opcoes,
      }
    }

    case types.NUMERACAO_DE_SERIE_ARMA_DE_FOGO: {
      return {
        ...state,
        numeracaoDeSerieArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_TAMBOR_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoTamborArmaDeFogo: action.opcoes,
      }
    }

    case types.TIPO_TELHA_ARMA_DE_FOGO: {
      return {
        ...state,
        tipoTelhaArmaDeFogo: action.opcoes,
      }
    }

    case types.CALIBRE_NOMINAL_CARTUCHO: {
      return {
        ...state,
        calibreNominalCartucho: action.opcoes,
      }
    }

    case types.CAPSULA_ESPOLETAMENTO_CARTUCHO: {
      return {
        ...state,
        capsulaEspoletamentoCartucho: action.opcoes,
      }
    }

    case types.FABRICANTE_CARTUCHO: {
      return {
        ...state,
        fabricanteCartucho: action.opcoes,
      }
    }

    case types.TIPO_ESTOJO_CARTUCHO: {
      return {
        ...state,
        tipoEstojoCartucho: action.opcoes,
      }
    }

    case types.TIPO_PROJETIL_CARTUCHO: {
      return {
        ...state,
        tipoProjetilCartucho: action.opcoes,
      }
    }

    case types.CALIBRE_COMPATIVEL_ELEMENTO_MUNICAO: {
      return {
        ...state,
        calibreCompativelElementoMunicao: action.opcoes,
      }
    }

    case types.ESPECIE_ELEMENTO_MUNICAO: {
      return {
        ...state,
        especieElementoMunicao: action.opcoes,
      }
    }

    case types.RESSALTOS_E_CAVADOS_ELEMENTO_MUNICAO: {
      return {
        ...state,
        ressaltosECavadosElementoMunicao: action.opcoes,
      }
    }

    case types.TIPO_ELEMENTO_MUNICAO: {
      return {
        ...state,
        tipoElementoMunicao: action.opcoes,
      }
    }

    case types.CARACTERISTICA_CARTUCHO: {
      return {
        ...state,
        caracteristicasCartucho: action.opcoes,
      }
    }

    case types.AUTORIDADES_REQUISITANTES: {
      return {
        ...state,
        autoridadesRequisitantes: action.autoridadesRequisitantes,
      }
    }

    case types.TIPOS_VESTIGIOS_GERAIS: {
      return {
        ...state,
        tiposVestigios: action.tiposVestigios,
      }
    }

    case types.TIPOS_VESTIGIOS: {
      return {
        ...state,
        tiposVestigiosGenericos: action.tiposVestigiosGenericos,
      }
    }

    case types.TIPOS_VESTIGIOS_ESPECIFICOS: {
      return {
        ...state,
        tiposVestigiosEspecificos: action.tiposVestigiosEspecificos,
      }
    }

    case types.TIPOS_VESTIGIOS_BALISTICA: {
      return {
        ...state,
        tiposVestigiosBalistica: action.tiposVestigiosBalistica,
      }
    }

    case types.TIPOS_SOLICITACOES: {
      return {
        ...state,
        tiposSolicitacoes: action.tiposSolicitacoes,
      }
    }

    case types.OPCOES_USUARIOS: {
      return {
        ...state,
        usuarios: action.usuarios,
      }
    }

    case types.OPCOES_SETORES: {
      return {
        ...state,
        setores: action.setores,
      }
    }

    case types.OPCOES_TIPOS_EXAMES: {
      return {
        ...state,
        tiposExames: action.tiposExames,
      }
    }

    case types.TIPOS_FENOMENOS_CADAVERICOS: {
      return {
        ...state,
        tiposFenomenosCadavericos: action.opcoes,
      }
    }

    case types.TIPOS_LESOES: {
      return {
        ...state,
        tiposLesoes: action.opcoes,
      }
    }

    case types.CAUSAS_MORTE: {
      return {
        ...state,
        causasMorte: action.opcoes,
      }
    }

    default: {
      return {
        ...state,
      }
    }
  }
}

export default optionReducer
